'use client';

import { ReactNode, useState } from 'react';

import { Box, Icon, IconName, Image, Price, Sticker, VariantState, View } from '@bytel/trilogy-react-ts';

import { classNames } from '@helpers/classnames';

interface OptionWithPriceProps {
    amount: number;
    period?: string;
    subTitle?: string | ReactNode;
    subTitleClassName?: string;
    titleClassName?: string;
    className?: string;
    priceLevel?: number;
    children?: ReactNode;
    small_image?: string;
    updatable?: boolean;
    handleDelete?: () => void;
    alt?: string;
}
export function OptionWithPrice({
    amount,
    period,
    children,
    priceLevel = 4,
    small_image,
    updatable,
    handleDelete,
    subTitle,
    alt,
}: Readonly<OptionWithPriceProps>) {
    const [isExpanded, setIsExpanded] = useState(false);

    const handleEdit = () => {
        setIsExpanded(!isExpanded);
    };

    const handleConfirm = () => {
        setIsExpanded(false);
    };

    return (
        <Box shadowless className='is-paddingless is-clipped is-bordered mb-4'>
            <View flexable>
                <div
                    className='level is-mobile animated px-2 mb-0'
                    style={{ flexGrow: 1, maxWidth: isExpanded ? 'calc(100% - 100px)' : '100%' }}
                >
                    <Image
                        src={`https://www.bouyguestelecom.fr${small_image}`}
                        className='has-background-white mt-0'
                        style={{
                            objectFit: 'cover',
                            maxWidth: '75%',
                        }}
                        height={50}
                        width={94}
                        alt={alt || "Icone d'option"}
                    />
                    <div className='is-flex is-vertical level'>
                        {subTitle && (
                            <Sticker small variant={VariantState.PRIMARY} className='mt-3'>
                                {subTitle}
                            </Sticker>
                        )}
                        <Price
                            amount={amount}
                            showCents
                            period={period}
                            level={priceLevel}
                            className={classNames(subTitle ? 'mb-3 pt-2' : '')}
                        />
                    </div>
                    {children}
                </div>
                {updatable && (
                    <div className='is-flex is-bordered px-3' style={{ borderWidth: '0px 0px 0px 1px' }}>
                        <div className='level-item mb-0'>
                            <button className='icon is-secondary is-small mt-0' onClick={handleEdit}>
                                <Icon name={IconName.PENCIL} accessibilityLabel="Modifier l'option" />
                            </button>
                        </div>

                        <div
                            style={{
                                position: 'absolute',
                                right: isExpanded ? 0 : -100,
                                height: '100%',
                            }}
                            className='is-flex animated'
                        >
                            <div className='level-item mb-0 has-background-success px-3'>
                                <button className='icon is-small' onClick={handleConfirm}>
                                    <Icon
                                        name={IconName.CHECK}
                                        className='is-white'
                                        accessibilityLabel="Confirmer l'option"
                                    />
                                </button>
                            </div>
                            <div className='level-item mb-0 has-background-error px-3'>
                                <button className='icon is-small' onClick={handleDelete}>
                                    <Icon
                                        name={IconName.TRASH}
                                        className='is-white'
                                        accessibilityLabel="Supprimer l'option"
                                    />
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </View>
        </Box>
    );
}
